var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69857 8.21486C12.1671 5.04257 16.0243 3 20.3571 3C20.5276 3 20.6912 3.06773 20.8117 3.18829C20.9323 3.30885 21 3.47236 21 3.64286C21 7.97657 18.9574 11.8329 15.7851 14.3023C15.9171 15.1288 15.8681 15.9741 15.6417 16.7798C15.4152 17.5855 15.0166 18.3325 14.4734 18.9693C13.9302 19.606 13.2554 20.1173 12.4954 20.4679C11.7354 20.8185 10.9084 21 10.0714 21C9.90093 21 9.73742 20.9323 9.61686 20.8117C9.4963 20.6912 9.42857 20.5276 9.42857 20.3571V16.8163C8.59536 16.1583 7.84222 15.4049 7.18457 14.5714H3.64286C3.47236 14.5714 3.30885 14.5037 3.18829 14.3831C3.06773 14.2626 3 14.0991 3 13.9286C2.99993 13.0915 3.18149 12.2644 3.53213 11.5044C3.88278 10.7443 4.39417 10.0694 5.03101 9.52621C5.66785 8.983 6.41497 8.58445 7.22081 8.35804C8.02665 8.13164 8.87202 8.08279 9.69857 8.21486V8.21486ZM14.5714 7.5C14.0599 7.5 13.5694 7.70319 13.2077 8.06487C12.846 8.42654 12.6429 8.91708 12.6429 9.42857C12.6429 9.94006 12.846 10.4306 13.2077 10.7923C13.5694 11.154 14.0599 11.3571 14.5714 11.3571C15.0829 11.3571 15.5735 11.154 15.9351 10.7923C16.2968 10.4306 16.5 9.94006 16.5 9.42857C16.5 8.91708 16.2968 8.42654 15.9351 8.06487C15.5735 7.70319 15.0829 7.5 14.5714 7.5V7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.c2f79097eeca7afd115d40e63dfd412a.svg";
export { ForwardRef as ReactComponent };